module.exports = __webpack_public_path__ + "img/pattern_01.6c934bfb.svg";